import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Row } from 'react-bootstrap'
import { GlgLoadingSpinner } from 'SharedComponents'
import MembershipNameComponent from './membership_name_component'
import RenewalDateComponent from './renewal_date_component'
import JoinDateComponent from './join_date_component'

class MembershipProgramsComponent extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let membershipPrograms = []
    if (!this.props.dataIsLoading) {
      membershipPrograms = Object.values(this.props.memberships)
    }
    
    let membershipTitle
    if (Object.keys(this.props.memberships).length > 0) {
      membershipTitle = (
        <Row className='title'>
          <span>
            { !window.I18n ? '' : window.I18n.t('player_activity.registration.membership.memberships') }
          </span>
          {this.props.membershipPortalLink && (
            <a className='edit-btn' href={ this.props.membershipPortalLink } target={ this.props.target }>
              <i className='fa fa-edit' />
              { ' ' + !window.I18n ? '' : window.I18n.t('player_activity.registration.membership.edit_memberships') }
            </a>
          )}
        </Row>
      )
    }
    
    return (
      <div className='membership-programs'>
        { membershipTitle }
        <GlgLoadingSpinner show={ this.props.dataIsLoading } />
        { 
          membershipPrograms.map((e, index) => {
            const colSmSize = e.renewal_date ? 4 : 6
            const renewalDateComp = e.renewal_date ? (
              <RenewalDateComponent
                renewalDate={ e.renewal_date }
                colSmSize={ colSmSize }
                isExpired={ e.isExpired }
                membershipPortalLink={ this.props.membershipPortalLink }
                target={ this.props.target } />
            ) : ''
            return (
              <Row
                className='no-lateral-margin'
                key={ index }
              >
                <MembershipNameComponent membershipName={ e.name } colSmSize={ colSmSize } />
                <JoinDateComponent joinDate={ e.join_date } colSmSize={ colSmSize } />
                { renewalDateComp }
              </Row>
            )
          })
        }
      </div>
    )
  }
}

MembershipProgramsComponent.propTypes = {
  memberships: PropTypes.object.isRequired,
  membershipPortalLink: PropTypes.string,
  dataIsLoading: PropTypes.bool,
  target: PropTypes.string,
}

export default MembershipProgramsComponent
